// extracted by mini-css-extract-plugin
export default {"permissionList":"PermissionList_permissionList__1vgkc"};